import { render, staticRenderFns } from "./perFile1.vue?vue&type=template&id=891e7c6c&scoped=true&"
import script from "./perFile1.vue?vue&type=script&lang=js&"
export * from "./perFile1.vue?vue&type=script&lang=js&"
import style0 from "./perFile1.vue?vue&type=style&index=0&lang=css&"
import style1 from "./perFile1.vue?vue&type=style&index=1&id=891e7c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891e7c6c",
  null
  
)

export default component.exports